/**
 * Created by phuongho on 7/12/16.
 */
import { BaseModel } from './base.model';
import { Json } from '../modules';
import { ValidateModel } from './validate.model';

export class SettingModel extends BaseModel {
  @Json('value')
  public value: string = undefined;

  @Json('keyword')
  public keyword: string = undefined;

  constructor() {
    super();
    this.validateRules = new ValidateModel();
    this.initValidateRules();
  }

  public initValidateRules(): ValidateModel {
    this.addRule('value', 'required', true, this._t('Value can not be blank.'));
    this.addRule('keyword', 'required', true, this._t('Keyword can not be blank.'));

    return this.getRules();
  }
}
